import React from 'react';
import styled from 'styled-components';
import Text from '../text/text';
import themedFontSize from '../../../styles/theme/themed-font-size';
import themedColor from '../../../styles/theme/themed-color';
import mediaBreakpoints from '../../../styles/media-breakpoints';

interface TitleProps {
  text: string;
}

const Title: React.FunctionComponent<TitleProps> = ({ text }) => {
  return <StyledTitle tParams={`${text}`} />;
};

const StyledTitle = styled(Text)`
  &.ucf-paragraph {
    font-size: ${themedFontSize('DISPATCH_PAGE_TITLE_XS')};
    margin: 0;
    color: ${themedColor('TEXT_BLUE')};
    text-align: center;
    white-space: pre;
    font-weight: 700;

    ${mediaBreakpoints.between('XS', 'M')`
    font-size: ${themedFontSize('DISPATCH_PAGE_TITLE_M')};
    white-space:normal;
    font-weight: 600;
  `};

    ${mediaBreakpoints.greaterThan('M')`
    font-size: ${themedFontSize('DISPATCH_PAGE_TITLE')};
    white-space:normal;
    font-weight: 600;
  `};
  }
`;

export default Title;
